export default __webpack_public_path__ + "static/media/trash_gray.5a17531d.svg";